import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const AttributePageIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 264 126">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h264v125.832H0z" />
      <circle opacity={0.4} cx={34.093} cy={27.458} fill="#2962FF" fillOpacity={0.3} r={19.122} />
      <rect x={169} y={65} width={81} height={53} rx={3} fill="#fff" />
      <path
        opacity={0.6}
        d="M173.889 78v-6.476h1.846c.362 0 .691.033.987.099.303.065.559.174.77.325.211.145.375.34.494.583.118.243.177.543.177.898 0 .342-.059.638-.177.889-.112.25-.274.457-.484.622-.211.164-.464.29-.76.375-.29.079-.612.118-.968.118h-1.066V78h-.819Zm.819-3.238h.967c.566 0 .984-.105 1.254-.316.277-.217.415-.556.415-1.017 0-.467-.145-.79-.435-.967-.283-.185-.707-.277-1.273-.277h-.928v2.577Zm6.49 3.356a2.45 2.45 0 0 1-.909-.167 2.305 2.305 0 0 1-.73-.494 2.391 2.391 0 0 1-.484-.79 2.948 2.948 0 0 1-.178-1.056c0-.395.06-.747.178-1.056.125-.316.286-.583.484-.8.204-.217.434-.382.691-.494.257-.118.523-.177.8-.177.302 0 .572.052.809.157.244.106.444.257.602.455.165.197.29.434.375.71.086.277.129.586.129.928 0 .086-.003.172-.01.257a.974.974 0 0 1-.02.208h-3.238c.033.513.191.92.474 1.224.29.296.665.444 1.125.444.231 0 .441-.033.632-.099a2.97 2.97 0 0 0 .563-.276l.286.533c-.21.132-.444.247-.701.345a2.43 2.43 0 0 1-.878.148Zm-1.511-2.902h2.567c0-.487-.105-.856-.316-1.106-.204-.256-.494-.385-.869-.385-.171 0-.335.033-.493.099-.152.066-.29.165-.415.296-.125.125-.23.28-.316.464a2.244 2.244 0 0 0-.158.632Zm6.422 2.903c-.296 0-.579-.056-.849-.168a2.127 2.127 0 0 1-.701-.484 2.517 2.517 0 0 1-.494-.79 3.03 3.03 0 0 1-.177-1.066c0-.402.059-.757.177-1.066.125-.316.29-.583.494-.8a2.063 2.063 0 0 1 1.55-.661 2.122 2.122 0 0 1 1.55.661c.204.217.365.484.484.8.125.309.187.664.187 1.066 0 .395-.062.75-.187 1.066-.119.31-.28.573-.484.79-.204.21-.441.372-.711.484a2.122 2.122 0 0 1-.839.168Zm0-.672c.204 0 .391-.043.563-.128.171-.092.315-.217.434-.375.125-.165.22-.359.286-.583.066-.224.099-.474.099-.75s-.033-.527-.099-.75a1.776 1.776 0 0 0-.286-.593 1.187 1.187 0 0 0-.434-.375 1.172 1.172 0 0 0-.563-.138 1.17 1.17 0 0 0-.563.138c-.171.086-.319.21-.444.375a1.888 1.888 0 0 0-.277.593 2.686 2.686 0 0 0-.098.75c0 .276.033.526.098.75.066.224.158.418.277.583.125.158.273.283.444.375.171.085.359.128.563.128Zm3.577 2.577v-6.822h.672l.069.553h.029c.217-.184.454-.342.711-.474.263-.132.537-.197.82-.197.309 0 .582.059.819.177.237.112.434.277.592.494.158.21.277.467.356.77.085.296.128.632.128 1.007 0 .408-.056.773-.168 1.096a2.538 2.538 0 0 1-.454.81 1.978 1.978 0 0 1-.661.513c-.25.112-.514.168-.79.168-.224 0-.448-.05-.672-.149a3.452 3.452 0 0 1-.661-.404l.02.839v1.619h-.81Zm1.985-2.587c.197 0 .378-.043.543-.128.171-.092.315-.217.434-.375a1.77 1.77 0 0 0 .286-.602c.073-.237.109-.504.109-.8 0-.263-.023-.504-.069-.72a1.507 1.507 0 0 0-.227-.554 1.01 1.01 0 0 0-.395-.365 1.188 1.188 0 0 0-.573-.128 1.32 1.32 0 0 0-.622.168 3.706 3.706 0 0 0-.661.483v2.518c.217.184.428.316.632.395.204.072.385.108.543.108Zm4.443.681c-.31 0-.53-.092-.662-.276-.131-.184-.197-.454-.197-.81v-6.061h.809v6.12c0 .132.023.225.07.277a.204.204 0 0 0 .157.08h.07a.42.42 0 0 0 .108-.02l.109.612a.698.698 0 0 1-.188.059c-.072.013-.164.02-.276.02Zm3.695 0a2.45 2.45 0 0 1-.909-.167 2.305 2.305 0 0 1-.73-.494 2.375 2.375 0 0 1-.484-.79 2.948 2.948 0 0 1-.178-1.056c0-.395.06-.747.178-1.056.125-.316.286-.583.484-.8.204-.217.434-.382.691-.494.257-.118.523-.177.799-.177.303 0 .573.052.81.157.244.106.444.257.602.455.165.197.29.434.375.71.086.277.129.586.129.928 0 .086-.004.172-.01.257a.974.974 0 0 1-.02.208h-3.238c.033.513.191.92.474 1.224.289.296.665.444 1.125.444.231 0 .441-.033.632-.099a2.97 2.97 0 0 0 .563-.276l.286.533c-.21.132-.444.247-.701.345a2.43 2.43 0 0 1-.878.148Zm-1.511-2.902h2.567c0-.487-.105-.856-.316-1.106-.204-.256-.494-.385-.869-.385-.171 0-.335.033-.493.099-.152.066-.29.165-.415.296-.125.125-.23.28-.316.464a2.21 2.21 0 0 0-.158.632Z"
        fill="#212121"
      />
      <circle opacity={0.4} cx={179.5} cy={92.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={179.5} cy={107.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={194.5} cy={92.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={194.5} cy={107.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={209.5} cy={92.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={209.5} cy={107.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={224.5} cy={92.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={224.5} cy={107.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={239.5} cy={92.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <circle opacity={0.4} cx={239.5} cy={107.5} r={6.5} fill="#2962FF" fillOpacity={0.3} />
      <rect x={169} y={65} width={81} height={53} rx={3} stroke="#000" strokeOpacity={0.1} />
      <rect
        opacity={0.4}
        x={61}
        y={31.542}
        width={50.579}
        height={9.869}
        rx={4.935}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <path fill="#000" fillOpacity={0.12} d="M16.038 58.149h234.393v1H16.038z" />
      <rect
        opacity={0.4}
        x={14.804}
        y={71.72}
        width={83.888}
        height={9.869}
        rx={4.935}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={15.001}
        y={89}
        width={96}
        height={10}
        rx={5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={15.001}
        y={106}
        width={61}
        height={10}
        rx={5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={61}
        y={13}
        width={67}
        height={11}
        rx={5.5}
        fill="#2962FF"
        fillOpacity={0.3}
      />
    </svg>
  </SvgIcon>
);

export default AttributePageIcon;
